// src/pages/auth/ForgotPassword.js
import React, { useState } from "react";
import {
  Box,
  Form,
  Heading,
  Button,
  Anchor,
  Image,
  Text,
} from "../../components/elements";
import IconField from "../../components/fields/IconField";
import Logo from "../../components/Logo";
import data from "../../data/master/forgot.json";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setError("Email is required.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}common/forgot-password`,
        { email }
      );

      setSuccess(true);
      setError("");
    } catch (e) {
      setError(e.response?.data?.message || "Failed to send reset email. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="mc-auth">
      <Image
        className="mc-auth-pattern"
        src={data?.pattern.src}
        alt={data?.pattern.alt}
      />
      <Box className="mc-auth-group">
        <Logo
          src={data?.logo.src}
          alt={data?.logo.alt}
          href={data?.logo.path}
          className="mc-auth-logo"
        />
        <Heading as="h4" className="mc-auth-title">
          {data?.title}
        </Heading>

        <Form className="mc-auth-form">
          {success ? (
            <Box style={{ textAlign: "center", padding: "20px" }}>
              <Text style={{ color: "#4CAF50", fontSize: "18px", marginBottom: "15px" }}>
                ✓ Reset link sent!
              </Text>
              <Text style={{ marginBottom: "20px" }}>
                If your email is registered, you will receive a password reset link shortly.
                Please check your email inbox (and spam folder).
              </Text>
              <Button
                className={`mc-auth-btn ${data?.button.fieldSize}`}
                onClick={() => navigate("/login")}
              >
                Back to Login
              </Button>
            </Box>
          ) : (
            <>
              {/* Email */}
              <IconField
                icon="email"
                type="email"
                classes="h-sm"
                placeholder="Enter your email address"
                passwordVisible={false}
                required
                name="email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
              />

              {error && <Text className="mc-alert red">{error}</Text>}

              <Text style={{ fontSize: "14px", color: "#666", marginBottom: "15px" }}>
                Enter your email address and we'll send you a link to reset your password.
              </Text>

              {/* Submit button */}
              <Button
                className={`mc-auth-btn ${data?.button.fieldSize}`}
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Reset Link"}
              </Button>

              {/* Cancel button */}
              <Button
                className={`mc-auth-btn ${data?.button.fieldSize}`}
                onClick={() => navigate("/login")}
                style={{ marginTop: "10px", backgroundColor: "#6c757d" }}
              >
                Cancel
              </Button>
            </>
          )}
        </Form>

        <Box className="mc-auth-navigate">
          <Text as="span">{data?.navigate.title}</Text>
          <Anchor href={data?.navigate.path}>{data?.navigate.text}</Anchor>
        </Box>
      </Box>
    </Box>
  );
}
